import Keycloak from 'keycloak-js'
import { Config } from '@/services/ConfigService'

export default new Keycloak({
	url: Config.VUE_APP_KEYCLOAK_URL,
	realm: Config.VUE_APP_KEYCLOAK_REALM,
	clientId: Config.VUE_APP_KEYCLOAK_CLIENT_ID
})
